/**
 * KSP (Key Selling Points) Slider Block JavaScript
 * Only loaded when .ksp-slider-block is present on page
 * Requires: Swiper with EffectFade module
 * Note: Fade effect only on tablet and below (<=992px)
 */

const kspSliders = document.querySelectorAll('.ksp-slider-block');

if (kspSliders.length && window.Swiper) {
    kspSliders.forEach(function ($scope) {
        let swiperInstance = null;
        
        function shouldInitSwiper() {
            // Only initialize on tablet and below (<=992px)
            return window.innerWidth <= 992;
        }
        
        function initSwiper() {
            // Only initialize if we're on tablet or below
            if (!shouldInitSwiper()) {
                // Destroy if exists and we're on desktop
                if (swiperInstance) {
                    swiperInstance.destroy(true, true);
                    swiperInstance = null;
                }
                return;
            }
            
            // Don't reinitialize if already exists
            if (swiperInstance) {
                swiperInstance.update();
                return;
            }
            
            const config = {
                loop: false,
                init: true,
                speed: 800,
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                },
                slidesPerView: 1,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                }
            };
            
            swiperInstance = new Swiper($scope.querySelector('.slider-icon-list'), config);
            
            setTimeout(function () {
                if (swiperInstance) {
                    swiperInstance.update();
                }
            }, 1000);
        }
        
        // Initialize on load if needed
        initSwiper();
        
        // Handle resize (debounced)
        let resizeTimer;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(initSwiper, 250);
        });
    });
}

